export default {
  getOptions: (state) => state.options,
  getDialog: (state) => state.options.dialog,
  loading: (state) => state.options.loading
};
